import { render, staticRenderFns } from "./RedeemAmount.vue?vue&type=template&id=a569237a&scoped=true&"
import script from "./RedeemAmount.vue?vue&type=script&lang=js&"
export * from "./RedeemAmount.vue?vue&type=script&lang=js&"
import style0 from "./RedeemAmount.vue?vue&type=style&index=0&id=a569237a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a569237a",
  null
  
)

export default component.exports